<template>
  <div style="height:100%">
    <div style="height:92%;border-radius:8px;padding-top: 50px">
      <el-form :model="addParams" :rules="rules" ref="addParams" label-width="160px" size="small" style="width:500px">
        <el-form-item label="首页LOGO" prop="imagePath">
          <el-upload
              action="#"
              :show-file-list="false"
              :auto-upload="false"
              :on-change="imageChange">
            <img v-if="tempImagePath" :src="tempImagePath" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="中文标题" prop="zhTitle">
          <el-input v-model="addParams.zhTitle" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="英文标题" prop="enTitle">
          <el-input v-model="addParams.enTitle" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin-left: 160px">
        <el-button type="primary" @click="editSubMit('addParams')" size="mini">确 定</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      path:'/y-home-info',
      addParams: {
        id:"",
        enTitle: "",
        zhTitle: "",
        title:"",
        imagePath:""
      },
      rules: {
        enTitle: [
          { required: true, message: '请输入英文标题', trigger: 'blur' }
        ],
        zhTitle: [
          { required: true, message: '请输中文标题', trigger: 'blur' }
        ],
      },
      tempImagePath:""
    };
  },
  created() {
    this.getInfo()
  },
  methods:{
    getInfo() {
      this.axios({
        method: "get",
        url: this.path+"/detail"
      }).then((res) => {
        if(res.data.data != null && res.data.data != undefined){
          this.addParams = res.data.data;
          if(this.addParams.title != '' && this.addParams.title != null && this.addParams.title != undefined){
            let titleObj = JSON.parse( this.addParams.title)
            this.$set( this.addParams,"zhTitle", titleObj.zh)
            this.$set( this.addParams,"enTitle", titleObj.en)
          }
          this.tempImagePath = "/api/file/check-image?filePath="+this.addParams.imagePath
        }
      });
    },

    editSubMit(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return false
        }else {
          let titleObj = {}
          titleObj.zh = this.addParams.zhTitle
          titleObj.en = this.addParams.enTitle
          this.addParams.title = JSON.stringify(titleObj)
          this.axios({
            method: "post",
            url: this.path+"/add",
            data: this.addParams,
          }).then((res) => {
            if (res.data.code === 200) {
              this.dialogFormEdit = false;
              this.$message({message: "修改成功",type: "success"});
              this.list();
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      })
    },
    imageChange(file){
      let obj = {}
      obj.name = file.name
      let param = new FormData(); //创建form对象
      param.append('file',file.raw);
      this.axios({
        method:"post",
        url:"/file/upload",
        data:param
      }).then((res)=>{
        let filePath = res.data.data.filePath
        this.addParams.imagePath = filePath
        this.tempImagePath = "/api/file/check-image?filePath="+filePath
      })
    },
  }
};
</script>

<style>

</style>